<template>
  <v-app-bar color="primary">
    <v-container class="d-flex align-center">
      <!-- logo -->
      <router-link to="/">
        <v-img :src="logo" alt="Warnerlaine" width="80" height="80"></v-img>
      </router-link>
      <!-- Show navigation only if authenticated -->
      <template v-if="authStore.isAuthenticated">

      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" variant="text">
            Sales
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
              to="/sales"
              prepend-icon="mdi-store-search"
              title="Quick search"
            ></v-list-item>
            
            <v-list-item
              to="/sales/all"
              prepend-icon="mdi-store-search"
              title="View All Sales"
            ></v-list-item>

            <v-divider></v-divider>
            <v-list-item
              to="/sales/late-shipments"
              prepend-icon="mdi-clock-time-eight-outline"
              title="Late shipments"
            ></v-list-item>

            <v-list-item
              to="/sales/delayed-shipments"
              prepend-icon="mdi-clock-time-eight-outline"
              title="Delayed shipments"
            ></v-list-item>
            
            <v-divider></v-divider>
          <v-list-item
            v-if="storesStore.loading"
            prepend-icon="mdi-loading"
            title="Loading stores..."
          ></v-list-item>

          <v-list-item
            v-else-if="storesStore.error"
            prepend-icon="mdi-alert"
            title="Error loading stores"
            :subtitle="storesStore.error"
          ></v-list-item>

          <template v-else>
            <v-list-item
              v-for="store in storesStore.stores"
              :key="store.slug"
              :to="`/sales/${store.slug}`"
              :title="store.name"
              :prepend-icon="getStoreIcon(store.marketplace)"
            ></v-list-item>
          </template>
          <v-divider></v-divider>
          <v-list-item
              to="/sales/import"
              prepend-icon="mdi-file-import"
              title="Import Data"
            ></v-list-item>
            <v-list-item
              to="/sales/export"
              prepend-icon="mdi-file-export"
              title="Export Data"
            ></v-list-item>
        </v-list>
      </v-menu>

      <!-- Vendors Dropdown -->
      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn
            v-bind="props"
            variant="text"
          >
            Order
            <v-icon end>mdi-chevron-down</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-if="vendorsStore.loading"
            prepend-icon="mdi-loading"
            title="Loading vendors..."
          ></v-list-item>

          <v-list-item
            v-else-if="vendorsStore.error"
            prepend-icon="mdi-alert"
            title="Error loading vendors"
            :subtitle="vendorsStore.error"
          ></v-list-item>

          <template v-else>
            <v-list-item
              v-for="vendor in vendorsStore.vendors"
              :key="vendor.slug"
              :to="`/order/${vendor.slug}`"
              :title="vendor.vendor"
            ></v-list-item>
            
            <v-divider></v-divider>
            
            <v-list-item
              to="/order/other"
              prepend-icon="mdi-cart"
              title="Other"
            ></v-list-item>
          </template>
        </v-list>
      </v-menu>

      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" variant="text">
            Returns
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
              to="/returns"
              prepend-icon="mdi-package-variant-closed"
              title="Returns"
            ></v-list-item>
            <v-list-item
              to="/returns/ebay"
              prepend-icon="mdi-package-variant-closed"
              title="eBay Returns"
            ></v-list-item>
        </v-list>
      </v-menu>
      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" variant="text">
            Manage
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-if="authStore.isAdmin"
            to="/manage/expenses"
            prepend-icon="mdi-cash-minus"
            title="Expenses"
          ></v-list-item>
          <v-list-item
            v-if="authStore.isAdmin"
            to="/manage/credits"
            prepend-icon="mdi-cash-plus"
            title="Credits"
          ></v-list-item>
          <v-list-item
            to="/manage/ebay-accounts"
            prepend-icon="mdi-alpha-e-box-outline"
            title="Ebay Accounts"
          ></v-list-item>
          <v-list-item
            to="/manage/reprice-formulas"
            title="Reprice Formulas"
            prepend-icon="mdi-calculator"
          ></v-list-item>
        </v-list>
      </v-menu>
      <v-menu>
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" variant="text">
            Inventory
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list v-if="authStore.isAdmin">
          <v-list-item
            to="/inventory/stock-items"
            prepend-icon="mdi-package-variant-closed"
            title="Stock Items"
          ></v-list-item>
          <v-list-item
            to="/inventory/amazon-stores"
            prepend-icon="mdi-alpha-a-box-outline"
            title="Amazon Stores"
          ></v-list-item>
          <v-list-item
            to="/inventory/ebay-stores"
            prepend-icon="mdi-alpha-e-box-outline"
            title="eBay Stores"
          ></v-list-item>
          <v-list-item
            to="/inventory/walmart-stores"
            prepend-icon="mdi-alpha-w-box-outline"
            title="Walmart Stores"
          ></v-list-item>
          <v-list-item
            to="/inventory/import-cost-shipping"
            prepend-icon="mdi-file-import"
            title="Import Cost & Shipping">
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu v-if="authStore.isAdmin">
        <template v-slot:activator="{ props }">
          <v-btn v-bind="props" variant="text">
            Reports
            <v-icon>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            to="/reports/daily-profits"
            title="Daily Profit"
            prepend-icon="mdi-cash-multiple"
          ></v-list-item>
          <v-list-item
            to="/reports/daily-average"
            title="Daily Average"
            prepend-icon="mdi-cash-multiple"
          ></v-list-item>
          <v-list-item
            to="/reports/monthly-profits"
            title="Monthly Profit"
            prepend-icon="mdi-cash-multiple"
          ></v-list-item>
          <v-list-item
            to="/reports/yearly-profits"
            title="Yearly Profit"
            prepend-icon="mdi-cash-multiple"
          ></v-list-item>

        </v-list>
      </v-menu>
      <v-spacer></v-spacer>
      <h3 class="mx-4">New Server</h3>
      <v-divider vertical></v-divider>
        <v-btn
          variant="text"
          @click="handleLogout"
        >
          Logout
        </v-btn>
      </template>
      <template v-else>
        <v-btn
          variant="text"
          to="/login"
        >
          Login
        </v-btn>
      </template>
    </v-container>
  </v-app-bar>
</template>

<script setup>
import { onMounted } from 'vue'
import { useStoresStore } from '@/stores/storesStore'
import { useVendorsStore } from '@/stores/vendorsStore'
import { useAuthStore } from '@/stores/authStore'
import { useRouter } from 'vue-router'
import logo from '@/assets/logo.png'
const storesStore = useStoresStore()
const vendorsStore = useVendorsStore()
const authStore = useAuthStore()
const router = useRouter()

const handleLogout = () => {
  authStore.logout()
  router.push('/login')
}

// const logo = logo

onMounted(() => {
  storesStore.fetchStores()
  vendorsStore.fetchVendors()
})

const getStoreIcon = (marketplace) => {
  switch (marketplace) {
    case 'Amazon':
      return 'mdi-alpha-a-box-outline';
    case 'eBay':
      return 'mdi-alpha-e-box-outline';
    case 'Walmart':
      return 'mdi-alpha-w-box-outline';
  }
}
</script> 